const map = {
	"./IconBox.svg": 59516,
	"./Icon_info_circle.svg": 51627,
	"./Icon_info_white.svg": 58746,
	"./afinando_o_cerebro.svg": 69145,
	"./afinando_plus.svg": 30731,
	"./audbility.svg": 18771,
	"./audiofoco.svg": 98763,
	"./button_close.svg": 54291,
	"./cart-plus-solid.svg": 87195,
	"./check_square_regular.svg": 2721,
	"./circle-check-gray.svg": 89171,
	"./circle-check-green.svg": 17543,
	"./header_calendar.svg": 81362,
	"./header_kart.svg": 56754,
	"./header_no_plan.svg": 72369,
	"./header_plan_base.svg": 53771,
	"./header_plan_gold.svg": 59110,
	"./header_plan_plationum.svg": 86685,
	"./header_plan_silver.svg": 48135,
	"./iconCoinPanel.svg": 57324,
	"./iconPersonPanel.svg": 19700,
	"./icon_abacus.svg": 48633,
	"./icon_add_users.svg": 49672,
	"./icon_adduser.svg": 64692,
	"./icon_aside_afinandoplus.svg": 40141,
	"./icon_aside_chat.svg": 72469,
	"./icon_aside_medal.svg": 53400,
	"./icon_aside_play.svg": 65789,
	"./icon_aside_task.svg": 15864,
	"./icon_aside_windows.svg": 15498,
	"./icon_bin.svg": 19551,
	"./icon_buttons_joystick.svg": 93132,
	"./icon_calendar.svg": 24110,
	"./icon_check.svg": 70388,
	"./icon_coins.svg": 57642,
	"./icon_edit.svg": 60968,
	"./icon_filter.svg": 42650,
	"./icon_headphone.svg": 70346,
	"./icon_info.svg": 20768,
	"./icon_message.svg": 67385,
	"./icon_pencil.svg": 42595,
	"./icon_play.svg": 75170,
	"./icon_print.svg": 36409,
	"./icon_question.svg": 35040,
	"./icon_sac.svg": 30479,
	"./icon_search.svg": 20992,
	"./icon_send.svg": 66046,
	"./icon_sound.svg": 27329,
	"./medalha_ativa.svg": 1412,
	"./medalha_inativa.svg": 38635,
	"./patient.svg": 98429,
	"./personal.svg": 71658,
	"./planoProfissional.svg": 19127,
	"./professional.svg": 78939,
	"./rotate-left-solid.svg": 6201,
	"./shopImage.svg": 30437,
	"./square_regular.svg": 27358,
	"./store_icon.svg": 95803,
	"./usuariosMais.svg": 5175,
	"./xmark-solid.svg": 80364,
	"./youtube.svg": 67921,
	"assets/images/icons/IconBox.svg": 59516,
	"assets/images/icons/Icon_info_circle.svg": 51627,
	"assets/images/icons/Icon_info_white.svg": 58746,
	"assets/images/icons/afinando_o_cerebro.svg": 69145,
	"assets/images/icons/afinando_plus.svg": 30731,
	"assets/images/icons/audbility.svg": 18771,
	"assets/images/icons/audiofoco.svg": 98763,
	"assets/images/icons/button_close.svg": 54291,
	"assets/images/icons/cart-plus-solid.svg": 87195,
	"assets/images/icons/check_square_regular.svg": 2721,
	"assets/images/icons/circle-check-gray.svg": 89171,
	"assets/images/icons/circle-check-green.svg": 17543,
	"assets/images/icons/header_calendar.svg": 81362,
	"assets/images/icons/header_kart.svg": 56754,
	"assets/images/icons/header_no_plan.svg": 72369,
	"assets/images/icons/header_plan_base.svg": 53771,
	"assets/images/icons/header_plan_gold.svg": 59110,
	"assets/images/icons/header_plan_plationum.svg": 86685,
	"assets/images/icons/header_plan_silver.svg": 48135,
	"assets/images/icons/iconCoinPanel.svg": 57324,
	"assets/images/icons/iconPersonPanel.svg": 19700,
	"assets/images/icons/icon_abacus.svg": 48633,
	"assets/images/icons/icon_add_users.svg": 49672,
	"assets/images/icons/icon_adduser.svg": 64692,
	"assets/images/icons/icon_aside_afinandoplus.svg": 40141,
	"assets/images/icons/icon_aside_chat.svg": 72469,
	"assets/images/icons/icon_aside_medal.svg": 53400,
	"assets/images/icons/icon_aside_play.svg": 65789,
	"assets/images/icons/icon_aside_task.svg": 15864,
	"assets/images/icons/icon_aside_windows.svg": 15498,
	"assets/images/icons/icon_bin.svg": 19551,
	"assets/images/icons/icon_buttons_joystick.svg": 93132,
	"assets/images/icons/icon_calendar.svg": 24110,
	"assets/images/icons/icon_check.svg": 70388,
	"assets/images/icons/icon_coins.svg": 57642,
	"assets/images/icons/icon_edit.svg": 60968,
	"assets/images/icons/icon_filter.svg": 42650,
	"assets/images/icons/icon_headphone.svg": 70346,
	"assets/images/icons/icon_info.svg": 20768,
	"assets/images/icons/icon_message.svg": 67385,
	"assets/images/icons/icon_pencil.svg": 42595,
	"assets/images/icons/icon_play.svg": 75170,
	"assets/images/icons/icon_print.svg": 36409,
	"assets/images/icons/icon_question.svg": 35040,
	"assets/images/icons/icon_sac.svg": 30479,
	"assets/images/icons/icon_search.svg": 20992,
	"assets/images/icons/icon_send.svg": 66046,
	"assets/images/icons/icon_sound.svg": 27329,
	"assets/images/icons/medalha_ativa.svg": 1412,
	"assets/images/icons/medalha_inativa.svg": 38635,
	"assets/images/icons/patient.svg": 98429,
	"assets/images/icons/personal.svg": 71658,
	"assets/images/icons/planoProfissional.svg": 19127,
	"assets/images/icons/professional.svg": 78939,
	"assets/images/icons/rotate-left-solid.svg": 6201,
	"assets/images/icons/shopImage.svg": 30437,
	"assets/images/icons/square_regular.svg": 27358,
	"assets/images/icons/store_icon.svg": 95803,
	"assets/images/icons/usuariosMais.svg": 5175,
	"assets/images/icons/xmark-solid.svg": 80364,
	"assets/images/icons/youtube.svg": 67921
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5016;